import http from '@/utils/request';

// 查询应用环境信息
export const queryAppEnvInfo = () => {
  const url = '/appEnv/queryAppEnvInfo';
  return http.get({
    url,
    isHideCommonParams: true,
  });
};

/**
 * 查询服务信息
 */
export const queryServerInfo = (params) => http.get({
  url: '/topologyAnalyze/queryServerInfo',
  params,
});

/**
 * 查询服务信息
 */
// export const queryOrganizationTree = (params) => http.get({
//   url: '/authManage/manager/government/organization_tree',
//   params,
// });

/**
 * 查询服务信息
 */
export const queryOrganizationTree = (params = {}) => http.get({
  url: '/baibu/auth/queryAllOrganization',
  params,
});
